import type { ShopListing } from "../contracts/shop";

type Price = Pick<ShopListing, "priceFromMinor" | "priceToMinor" | "currency" | "priceBasis">;

/** A quote range, with currency and unit always visible. No checkout or tax claim is implied. */
export function formatShopPrice(listing: Price): string {
  const format = (minor: number) =>
    new Intl.NumberFormat("en-GB", {
      minimumFractionDigits: minor % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2,
    }).format(minor / 100);
  const range =
    listing.priceToMinor !== null && listing.priceToMinor !== listing.priceFromMinor
      ? `${format(listing.priceFromMinor)}–${format(listing.priceToMinor)}`
      : format(listing.priceFromMinor);
  const basis = listing.priceBasis === "fixed" ? "fixed price" : `per ${listing.priceBasis}`;
  return `${listing.currency} ${range} ${basis}`;
}
